import { Instagram, MapPin, Heart } from "lucide-react";
import HeartWaveMark from "@/components/ui/HeartWaveMark";
import { TESTIDS, INSTAGRAM_URL, INSTAGRAM_HANDLE, LOCATION } from "@/lib/site";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid={TESTIDS.footer.container}
      className="relative bg-editorial-dark text-warm-beige/90 overflow-hidden"
    >
      {/* Soft top wave */}
      <svg
        aria-hidden
        viewBox="0 0 1440 60"
        className="absolute -top-px left-0 right-0 w-full text-warm-beige/40"
        preserveAspectRatio="none"
      >
        <path d="M0,40 C320,10 720,70 1440,20 L1440,0 L0,0 Z" fill="#F7F3EE" />
      </svg>

      <div className="relative max-w-7xl mx-auto px-6 md:px-10 pt-24 pb-10">
        {/* Closing phrase */}
        <div className="relative text-center max-w-3xl mx-auto">
          <Heart className="mx-auto text-dusty-rose" size={22} strokeWidth={1.4} />
          <p className="mt-5 font-serif text-2xl md:text-[2.1rem] italic text-warm-white leading-snug">
            &ldquo;Todo proceso emocional merece un espacio donde poder ser escuchado.&rdquo;
          </p>
        </div>

        <div className="mt-16 grid md:grid-cols-3 gap-10 items-start">
          <div>
            <div className="flex items-center gap-3">
              <span className="inline-flex w-12 h-12 rounded-full bg-warm-beige/15 border border-warm-beige/25 items-center justify-center text-dusty-rose">
                <HeartWaveMark className="w-7 h-7" strokeWidth={1.4} />
              </span>
              <p className="font-serif text-2xl text-warm-white">
                Berenice <span className="italic text-dusty-rose">Pavón</span>
              </p>
            </div>
            <p className="mt-3 text-sm text-warm-beige/70 max-w-xs">
              Psicóloga & Musicoterapeuta Humanista. Acompañamiento sensible, profesional
              y profundamente humano.
            </p>
          </div>

          <div>
            <p className="text-[0.72rem] tracking-[0.22em] uppercase text-dusty-rose/80 mb-3">
              Espacio
            </p>
            <p className="text-sm flex items-start gap-2 text-warm-beige/85">
              <MapPin size={16} className="mt-0.5 shrink-0 text-dusty-rose" />
              {LOCATION}
            </p>
            <p className="text-sm text-warm-beige/70 mt-3">
              Cédula Profesional 15510639
            </p>
          </div>

          <div>
            <p className="text-[0.72rem] tracking-[0.22em] uppercase text-dusty-rose/80 mb-3">
              Comunidad
            </p>
            <a
              data-testid={TESTIDS.footer.instagram}
              href={INSTAGRAM_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 text-warm-white hover:text-dusty-rose transition-colors"
            >
              <Instagram size={18} />
              {INSTAGRAM_HANDLE}
            </a>
          </div>
        </div>

        <div className="mt-16 pt-6 border-t border-warm-beige/15 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-warm-beige/60">
          <p>© {year} Berenice Pavón. Todos los derechos reservados.</p>
          <p className="italic">
            Hecho con calma, escucha y atención al detalle.
          </p>
        </div>
      </div>
    </footer>
  );
}
